import { ImageApi } from '@/api/domains/image.api';
import { useMutation } from '@tanstack/react-query';

export const useUploadImage = () =>
  useMutation({
    mutationFn: ImageApi.uploadImage,
  });
